import React from "react";
import "./Modal.scss";
import Button from "@components/button/Button";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";

export default function Modal({
  className = "",
  showModal = false,
  botaoExcluir = true,
  setShowModal = () => null,
  width = "",
  height = null,
  title = "",
  children = "",
  //Button001
  button001_Nome = "Sim",
  button001_onClick = () => null,
  showButton001 = false,
  button01_classname = "",
  //Button002
  button002_Nome = "Não",
  button002_onClick = () => null,
  showButton002 = false,
  button02_classname = "",
}) {
  return (
    <>
      {showModal && (
        <div className={`Modal`}>
          <div
            className={`modal-body col-12 col-sm-4 col-xl-3`}
            style={{
              width: width,
              ...(height && { height: height }),
              maxWidth: "calc(100% - 20px)",
            }}
          >
            <div className="modal-title">
              {title && (
                <p className="modal-title">
                  <strong>{title}</strong>
                </p>
              )}
              {botaoExcluir && (
                <ButtonIcon
                  Excluir
                  onExcluir={() => {
                    setShowModal(false);
                  }}
                />
              )}
            </div>
            <div className="body">{children}</div>
            <div className="modal-button">
              {showButton001 && (
                <Button
                  className={button01_classname}
                  nome={button001_Nome}
                  onClick={button001_onClick}
                  theme={2}
                />
              )}
              {showButton002 && (
                <Button
                  className={button02_classname}
                  nome={button002_Nome}
                  onClick={button002_onClick}
                  theme={2}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
